import "./PaymentMethods.css";

import { Elements, StripeProvider } from "react-stripe-elements";
import React, { Component } from "react";

import Api from "../services/api";
import AuthService from "../services/auth";
import PaypalExpressBtn from "react-paypal-express-checkout";
import StripeForm from "../components/StripeForm";
import config from "../config";
import gif from "../static/images/loader.gif";
import ideal from "../static/images/ideal.png";
import mastercard from "../static/images/mastercard.png";
import paypal from "../static/images/paypal.png";
import sofort from "../static/images/sofort.png";
import visa from "../static/images/visa.png";
import { withRouter } from "react-router-dom";

class PaymentMethods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlayVisible: false
    };
  }

  handlePaypalPaymentFinished(payment) {
    const { price, transactionType, chosenProduct, refCode } = this.props;

    new Api()
      .post(
        "/payment/create",
        {
          sourceId: payment.paymentID,
          chargeId: payment.paymentToken,
          product: chosenProduct,
          method: "paypal",
          amount: price,
          refCode: refCode,
          transactionType
        },
        AuthService.getAuthCookie()
      )
      .then(response => {
        if (response.success) {
          this.props.history.push(response.redirect);
        }
      });
  }

  showOverlay(show = true) {
    this.setState({
      overlayVisible: show
    });
  }

  render() {
    const {
      price,
      method,
      onMethodChange,
      ucdUser,
      transactionType,
      chosenProduct,
      refCode
    } = this.props;
    const { overlayVisible } = this.state;
    return (
      <div className="payment-methods">
        <div className="methods row">
          <div className="col col-12 col-md-6">
            <div
              className={`method ${method === "stripe" ? "active" : ""}`}
              onClick={() => onMethodChange("stripe")}
            >
              <div className="method-logos">
                <img src={mastercard} alt={"Mastercard"} className="logo" />
                <img src={visa} alt={"Visa"} className="logo" />
                <img src={ideal} alt={"iDeal"} className="logo" />
                <img src={sofort} alt={"Sofort"} className="logo" />
                <div className="more-text">and more&hellip;</div>
              </div>
            </div>
          </div>
          <div className="col col-12 col-md-6">
            <div
              className={`method ${method === "paypal" ? "active" : ""}`}
              onClick={() => onMethodChange("paypal")}
            >
              <div className="method-logos">
                <img src={paypal} alt={"Paypal"} className="logo" />
              </div>
            </div>
          </div>
        </div>
        <div className="row body">
          {method === "stripe" && (
            <div className="method-form-container">
              <StripeProvider apiKey={config.stripeConfig.apiKey}>
                <Elements>
                  <StripeForm
                    refCode={refCode}
                    ucdUser={ucdUser}
                    price={price}
                    product={chosenProduct}
                    transactionType={transactionType}
                    showOverlay={() => this.showOverlay()}
                  />
                </Elements>
              </StripeProvider>
            </div>
          )}
          {method === "paypal" && (
            <div className="method-form-container paypal">
              <PaypalExpressBtn
                onSuccess={payment => this.handlePaypalPaymentFinished(payment)}
                env={config.paypalEnv}
                client={config.paypalConfig}
                total={price}
                currency={"USD"}
                shipping={1}
                style={{
                  label: "paypal",
                  color: "blue",
                  shape: "rect",
                  size: "responsive"
                }}
              />
              <div
                className="method-form__button paypal"
                onClick={() => {
                  this.showOverlay();
                }}
              >
                Pay &#36;{price.toFixed(2)}
              </div>
            </div>
          )}
        </div>
        <div className={`overlay ${overlayVisible ? "visible" : "invisible"}`}>
          <img src={gif} alt="Loader" />
        </div>
      </div>
    );
  }
}

export default withRouter(PaymentMethods);



// WEBPACK FOOTER //
// ./src/components/PaymentMethods.js